(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-recommend-list"]) return;
  try {
    
  //   window.addEventListener("resize", function() {
  //   if (window.innerWidth < 950) {
  //     const inner_cont = document.querySelector('.news-container--content.d-flex')
  //     inner_cont.classList.remove("d-flex");
  //   }

  // });

  } catch(e) { console.error(e); }
})();
})();
